import { useEffect, useState } from "react";

const TABLET_BREAKPOINT = 768;
const DESKTOP_BREAKPOINT = 1024;

const useWindow = () => {
  const tabletMQ = `(min-width: ${TABLET_BREAKPOINT}px)`;
  const desktopMQ = `(min-width: ${DESKTOP_BREAKPOINT}px)`;

  const [state, setState] = useState({
    serverSide: true,
    isDesktop: false,
    isTablet: false,
    isMobile: false,
  });

  useEffect(() => {
    const tabletMediaQuery = window.matchMedia(tabletMQ);
    const desktopMediaQuery = window.matchMedia(desktopMQ);

    const tabletMediaQueryChange = (e) => {
      const updatedIsDesktop = e.media === desktopMQ && e.matches;
      const updatedIsTablet =
        (e.media === desktopMQ && !e.matches) ||
        (e.media === tabletMQ && e.matches);
      const updatedIsMobile = !updatedIsDesktop && !updatedIsTablet;

      setState({
        serverSide: false,
        isDesktop: updatedIsDesktop,
        isTablet: updatedIsTablet,
        isMobile: updatedIsMobile,
      });
    };

    const windowDefined = typeof window !== "undefined";
    const isDesktop = windowDefined && window.matchMedia(desktopMQ).matches;
    const isTablet =
      !isDesktop && windowDefined && window.matchMedia(tabletMQ).matches;
    const isMobile =
      !isDesktop &&
      !isTablet &&
      windowDefined &&
      window.innerWidth < TABLET_BREAKPOINT;

    setState({
      serverSide: false,
      isDesktop,
      isTablet,
      isMobile,
    });

    // addListener used for backwards compatibility with ie and safari
    tabletMediaQuery.addListener(tabletMediaQueryChange);
    desktopMediaQuery.addListener(tabletMediaQueryChange);
  }, []);

  return state;
};

export default useWindow;
